export const PLACEHOLDERS = {
    CASHBACK: '{{price}}',
    PUBLISHER_NAME: '{{name}}'
};
